import Layout from 'Nori/Layout';
import styles from 'styles/pages/safetyInformation.module.scss';
import ISI from 'Custom/ISI';
import Container from 'Nori/Container';

const HEAD = {
  title: 'Safety Information',
  description: '',
  keywords: '',
};

export default function faq() {
  return (
    <Layout head={HEAD} hideISI>
      <Container
        size="md"
        className={styles.isi}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="ISI - Page Bottom"
        data-design-module_name="ISI - Page Bottom"
        data-design-module_no="00"
      >
        <ISI noriId="ISI - Page Bottom" moduleTitle="ISI - Page Bottom" />
      </Container>
    </Layout>
  );
}
